export const isToday = (date: Date): boolean => {
  const input = new Date(date);
  const today = new Date();
  return (
    input.getDate() === today.getDate() &&
    input.getMonth() === today.getMonth() &&
    input.getFullYear() === today.getFullYear()
  );
};
